import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Navigation from "./navigation/Navigation";
import NavBar from "./components/navigation/NavBar";
import Footer from "./components/navigation/Footer";

function App() {
  return (
    <>
      <NavBar />
      <Navigation />
      <Footer />
    </>
  );
}

export default App;
